// extracted by mini-css-extract-plugin
export default {"container":"Profile_container__TXQ7d","alert":"Profile_alert__D50QB","column":"Profile_column__KV+tf"};